import React from "react";
import { Container } from "react-bootstrap";
import mobApp from "../../../../Asset/mobileApp/mobile-apps-2.svg";
import "../../../../App.css";
import { useNavigate } from "react-router-dom";

const Fourth = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/ContactUs");
  };
  return (
    <>
      <section
        className="sixth-mobileApp-section"
        style={{ backgroundColor: "var( --white-color)" }}
      >
        <Container>
          <div
            className="mob-dev-cta"
            style={{ backgroundColor: "var( --light-primary-bg)" }}
          >
            <div className="row">
              <div className="col-xl-8 col-md-8">
                <div className="sec-6-cta-card">
                  <h3>
                    <strong className="text-skyblue">
                      Discover How We Can Transform Your Logistics and Supply
                      Chain Operations Now!
                    </strong>
                  </h3>
                  <p onClick={handleNavigate} className="btn btn-primary">
                    Contact Us
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-md-4">
                <div className="cta-bg">
                  <img alt="infoImage" src={mobApp} className="w-100" />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Fourth;
